const errorCodes = {
    tooManyRequests: "tooManyRequests",
    featureDisabled: "featureDisabled",
    invalidEmail: "invalidEmail",
    invalidPassword: "invalidPassword",
    invalidMediaType: "invalidMediaType",
    pinLocked: "pinLocked"
};

export default {
    mediaTypes: {
        "email": "email"
    },
    errorCodes: {
        internal: errorCodes,
        api: {
            3: errorCodes.invalidEmail,
            4: errorCodes.invalidPassword,
            5: errorCodes.tooManyRequests,
            6: errorCodes.pinLocked,
            7: errorCodes.featureDisabled
        }
    }
};
